export default __webpack_public_path__ + "a136f3932e2944449b960bf7c87adb7e.png";